<template>
  <div class="what-get">
    <div class="container">
      <div class="subtitle">{{ $t('whatGet.subtitulo') }}</div>
      <div class="title">{{ $t('whatGet.titulo') }}</div>
      <div class="box-container">
        <div class="column">
          <div class="title">{{ $t('whatGet.bloque1.titulo') }}</div>
          <div v-html="$t('whatGet.bloque1.descripcion')" class="content"></div>
          <img v-if="!defaultSize" class="img-small" src="../assets/what-get-img-1.png" alt="">
        </div>
        <div class="column">
          <div class="title">{{ $t('whatGet.bloque2.titulo') }}</div>
          <div v-html="$t('whatGet.bloque2.descripcion')" class="content"></div>
          <img v-if="!defaultSize" class="img-small" src="../assets/what-get-img-2.png" alt="">
        </div>
      </div>
    </div>

    <div class="block-images">
      <div v-if="defaultSize" class="container">
        <div class="box-container">
          <div class="column">
            <img src="../assets/what-get-img-1.png" alt="">
          </div>
          <div class="column">
            <img src="../assets/what-get-img-2.png" alt="">
          </div>
        </div>
      </div>

      <div class="container">
        <div class="get-app-block">
          <div class="title">{{ $t('whatGet.download') }}</div>
          <div v-if="loaded && getLanguage === 'es'">
            <img src="../assets/buttons/get-app-android-es.svg" @click="goTo('android')" class="cursor-pointer ml-30 mr-40" alt="">
            <img src="../assets/buttons/get-app-ios-es.svg" @click="goTo('ios')" class="cursor-pointer" alt="">
          </div>
          <div v-if="loaded && getLanguage !== 'es'">
            <img src="../assets/buttons/get-app-android-en.svg" @click="goTo('android')" class="cursor-pointer ml-30 mr-40" alt="">
            <img src="../assets/buttons/get-app-ios-en.svg" @click="goTo('ios')" class="cursor-pointer" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import i18n from '../plugins/i18n.js'
export default {
  name: 'WhatGet',
  data: () => ({
    defaultSize: true,
    loaded: false
  }),
  created () {
    window.addEventListener('resize', this.checkBackgroundSize)
    this.checkBackgroundSize()
  },
  computed: {
    getLanguage () {
      return i18n.locale
    }
  },
  methods: {
    checkBackgroundSize () {
      if (window.innerWidth > 770 && !this.defaultSize) {
        this.defaultSize = true
      }
      if (window.innerWidth <= 770 && this.defaultSize) {
        this.defaultSize = false
      }
    },
    goTo (type) {
      let url = ''
      if (type === 'android') {
        url = this.$store.state.urlAndroid
      }
      if (type === 'ios') {
        url = this.$store.state.urlIos
      }
      window.open(url, '_blank')
    }
  },
  mounted () {
    this.loaded = true
  }
}
</script>

<style lang="scss" scoped>
.what-get {
  position: relative;
  width: 100%;
  background: url(../assets/bg-what-get.png) no-repeat 7% 0%, linear-gradient(180deg, #F7F9FF 0%, rgba(247, 249, 255, 0) 100%);
  font-size: 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 70px;
    padding-bottom: 140px;

    > div {
      width: 100%;
    }

    .subtitle {
      text-align: center;
      font-size: 24px;
      color: #444D67;
      margin-bottom: 15px;
    }

    .title {
      text-align: center;
      font-size: 56px;
      font-weight: 700;
      color: #4AC4D0;
      margin-bottom: 80px;
    }

    .box-container {
      display: flex;
      justify-content: space-between;

      .column {
        width: calc(100% - 50px);
        font-size: 16px;
        text-align: left;

        &:first-child {
          margin-right: 50px;
        }
        &:last-child {
          margin-left: 50px;
        }

        .title {
          font-weight: 600;
          font-size: 36px;
          margin-bottom: 20px;
          text-align: left;
          color: #444D67;
        }

        .content {
          color: #6E6E6E;
          line-height: 170%;
        }
      }
    }
  }

  .block-images {
    width: 100%;
    background: #f7f9ff;
    padding-top: 30px;

    .container {
      padding-top: 0;
      padding-bottom: 80px;
    }
    .box-container {
      margin-top: -125px;

      img {
        width: 100%;
      }
    }

    .get-app-block {
      display: flex;
      align-items: center;
      justify-content: space-around;

      .title {
        font-weight: 600;
        font-size: 30px;
        margin: 0;
        color: #444D67;
      }
    }
  }

  @media(max-width: 770px) {
    .block-images .container {
      padding-bottom: 60px;
    }
    .container {
        .box-container {
        flex-direction: column;

        .column {
          width: 100%;

          .img-small {
            width: 100%;
            margin-top: 35px;
            margin-bottom: 70px;
          }
          &:first-child,
          &:last-child {
            margin-left: 0;
            margin-right: 0;
          }

          &:last-child .img-small {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

@media(max-width: 1200px) {
  .what-get {
    font-size: 14px;

    .container .title {
      font-size: 44px;
    }

    .container .box-container .column {
      font-size: 14px;

      .title {
        font-size: 32px;
      }
    }

    .block-images .container .get-app-block .title {
      font-size: 26px;
    }
  }
}

@media(max-width: 1150px) {
  .what-get {
    .container .box-container .column .title {
      font-size: 32px;
    }

    .block-images .get-app-block {
      flex-direction: column;

      .title {
        margin-top: 30px;
        margin-bottom: 30px;
      }
    }
  }
}

@media(max-width: 900px) {
  .what-get {
    font-size: 14px;

    .container .box-container .column {
      font-size: 14px;

      .title {
        font-size: 28px;
      }
    }

    .block-images .container .get-app-block {
      img {
        height: 55px;
      }

      .title {
        font-size: 22px;
      }
    }
  }
}

@media(max-width: 450px) {
  .what-get {
    .block-images .container .get-app-block > div:nth-child(2) {
      display: flex;
      flex-direction: column;

      img {
        margin-left: 0 !important;
        margin-right: 0 !important;
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/what-get.vue